import type { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';

import type { Attachment } from './attachments.types';

export const { provide: provideAttachmentPdfRefresh, inject: injectAttachmentPdfRefresh } =
  createProviderToken<(attachment: Attachment) => Observable<Attachment | null>>(
    'ATTACHMENT_PDF_REFRESH',
  )();
